import { useEffect, useState, useMemo } from 'react';
import { userTokenService } from '@pwc/pwc-deals-web-common';
import { CommentsAdapter } from '@pwc/pwc-deals-ui';

const useCommentsAdapter = () => {
  const [isReady, setIsReady] = useState(false);

  const currentUser = useMemo(() => {
    return {
      id: userTokenService.getUserId(),
      name: userTokenService.getUserEmail(),
    };
  }, []);

  useEffect(() => {
    CommentsAdapter.prototype.PwcCurrentUser = currentUser;
    setIsReady(true);
  }, [currentUser]);

  return {
    isReady,
    currentUser,
    CommentsAdapter,
  };
};

export default useCommentsAdapter;
